import { format } from "date-fns";
import api from "../services/api";

interface IDebtorResponse {
    codeResult: string;
    data: any[];
}

export interface IDebtorParams {
    year: string;
    month: string;

}
export interface IDebtor {
    dataConf: string;
    gerente: string;
    representante: string;
    revendedor: string;
    revCrm: string;
    protestado: boolean;
    devedor: number;
    kit: number;
    ficha: boolean;
    kitId: string;
    valorVendido: number;
    valorReceber: number;
    valorRecebido: number;
    valorDebito: number;
}


class DebtsRepository {
    public async Debts({ year, month }: IDebtorParams): Promise<IDebtor[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Conference", "Kit", "Revendedor", "Representante", "GerenteSetor"],
            "sql": [
                {
                    "coderesult": "Debitos",
                    "query": `SELECT Conference.data AS Data, 
                    GerenteSetor.nome AS Gs, 
                    Representante.nome AS Rp, 
                    Revendedor.nome AS Rv, 
                    Revendedor.crm as Crm, 
                    Revendedor.devedor as Devedor, 
                    Kit.numero AS Numero, 
                    Kit.id as Id, 
                    Kit.ficha as Ficha, 
                    Revendedor.protestado as Protestado, 
                    Conference.valorVendido AS Vendido, 
                    (Conference.valorVendido - Conference.comissaoRevendedor) AS Receber, 
                    Conference.valorRecebido AS Recebido, 
                    (Conference.valorReceber - Conference.valorRecebido) AS Debito 
                    FROM Conference 
                    INNER JOIN Kit 
                    ON Kit.id = Conference.kitId 
                    LEFT JOIN Revendedor 
                    ON Revendedor.id = Kit.revendedorId 
                    LEFT JOIN Representante 
                    ON Representante.id = Revendedor.representanteId 
                    LEFT JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    WHERE Kit.estado = 1 
                    AND Conference.conferenceType = 0 
                    AND Conference.data > '${initialDate}' 
                    AND Conference.data < '${endDate}' 
                    ORDER BY GerenteSetor.nome, Representante.nome, Revendedor.nome, Kit.numero`
                }
            ]
        };

        const response = await api.post<IDebtorResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Debitos").map(result => {
            return {
                dataConf: result.Data,
                gerente: result.Gs,
                representante: result.Rp,
                revendedor: result.Rv,
                revCrm: result.Crm, 
                protestado: result.Protestado,
                devedor: result.Devedor,
                kit: result.Numero,
                ficha: result.Ficha,
                kitId: result.Id,
                valorVendido: result.Vendido,
                valorReceber: result.Receber,
                valorRecebido: result.Recebido,
                valorDebito: result.Debito
            }
        });
    }

    GetFromCodeResult(data: IDebtorResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const debtsRepository = new DebtsRepository();
export default debtsRepository;